import React from 'react'
import { ChargingSession } from '../../../../chargingSession/types/chargingSession.types'
import { OrderByType } from '../../../../../utils/genericAPI/useGenericAPI'
import ChargingSessionList from '../../../../chargingSession/components/ChargingSessionList'
import useSingleStation from '../../../hooks/useSingleStation'

export default function SingleStationChargingSessionList({pageSize, orberBy, stationId} : {pageSize?: number, orberBy?: OrderByType<ChargingSession>, stationId?: string}) {
    const {stationId : stationIdFound} =  useSingleStation(stationId)
  
    return (
    <>
        <ChargingSessionList.List preFilter={{cs_station: `=${stationIdFound}`}} sizePage={pageSize} orberBy={orberBy} />
    </>
  )
}
